import { Modal } from "@xola/ui-kit";
import React, { memo } from "react";
import { PhotoActionButtons } from "./PhotoActionButtons";

interface PhotoLightboxModalProps {
    isOpen: boolean;
    blobUrl: string;
    blob?: Blob;
    altText: string;
    photoPath?: string;
    onClose: () => void;
}

export const PhotoLightboxModal = memo(
    ({ isOpen, blobUrl, blob, altText, photoPath, onClose }: PhotoLightboxModalProps) => {
        if (!isOpen) {
            return null;
        }

        return (
            <Modal isOpen={isOpen} size="huge" onClose={onClose}>
                <Modal.Body className="flex flex-col items-center justify-center gap-4">
                    <img src={blobUrl} alt={altText} className="max-h-[80vh] max-w-full object-contain" />
                    <div className="flex items-center justify-center gap-3">
                        <PhotoActionButtons blobUrl={blobUrl} blob={blob} altText={altText} photoPath={photoPath} />
                    </div>
                </Modal.Body>
            </Modal>
        );
    },
);

PhotoLightboxModal.displayName = "PhotoLightboxModal";
